'use strict'

import ProductFavoriteButton from 'assets/core/js/module/productFavoriteButton'

export default (): void => {
  const elements = document.querySelectorAll<HTMLElement>('.product-actions__favorite')

  for (const element of elements) {
    ProductFavoriteButton(element, 'product page')
  }
}
